import script from "./GridDorape.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridDorape.vue?vue&type=script&setup=true&lang=ts"

import "./GridDorape.vue?vue&type=style&index=0&id=91f22d2c&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91f22d2c"]])

export default __exports__